import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from "@angular/forms";
import { FormService } from "../../services/form.service";

@Component( {
	selector: 'app-property-type-from',
	templateUrl: './property-type-from.component.html',
	styleUrls: ['./property-type-from.component.scss']
} )
export class PropertyTypeFromComponent implements OnInit {

	propertyTypeFrom !: UntypedFormGroup
	formGroupName: string = 'propertyTypeFrom'
	m2Enabled = false;
	public m2Sizes = [
		{
			value: 1,
			label: $localize`:@@lessThan59m2:Less than 59m2`,
		},
		{
			value: 2,
			label: $localize`:@@60to99m2:60 - 99m2`,
		},
		{
			value: 3,
			label: $localize`:@@moreThan100m2:More than 100m2`,
		}
	]

	// These are now the same as the apartment rooms
	// Originally they were different which is why there's 2 arrays
	public houseRooms = [
		{
			value: 1,
			label: $localize `:@@1bedroom:1-bedroom`,
		},
		{
			value: 2,
			label: $localize `:@@2bedroom:2-bedroom`,
		},
		{
			value: 3,
			label: $localize `:@@3bedroom:3-bedroom`,
		},
		{
			value: 4,
			label: $localize `:@@4bedroom:4-bedroom`,
		}
	];

	public apartmentRooms = [
		{
			value: 1,
			label: $localize `:@@1bedroom:1-bedroom`,
		},
		{
			value: 2,
			label: $localize `:@@2bedroom:2-bedroom`,
		},
		{
			value: 3,
			label: $localize `:@@3bedroom:3-bedroom`,
		},
		{
			value: 4,
			label: $localize `:@@4bedroom:4-bedroom`,
		}
	]

	constructor(public formService: FormService) {}

	ngOnInit(): void {

		this.propertyTypeFrom = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;
		this.m2Enabled = this.formService.mainForm.controls['_m2Enabled'].value;
	}

	onSubmit() {

		this.formService.submitFormGroup( (<UntypedFormGroup>this.propertyTypeFrom) );
	}

	onRadioChange( $event: any ) {

		// Don't do anything if m2 field is enabled
		if( this.m2Enabled )
			return;

		// Don't do anything if the propertyRooms is enabled
		if( this.formService.mainForm.controls['_propertyRoomsEnabled'].value ) {
			return;
		}

		// Small timeout for user experience
		setTimeout( () => {

			this.onSubmit();
		}, 200 );
	}

	getPropertyRooms() {

		return this.propertyTypeFrom.controls['propertyType'].value == 1 ? this.houseRooms : this.apartmentRooms;
	}
}
